import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { Save, Trash2, X } from 'lucide-react';
import './saveSession.css';

const SaveSessionModal = ({
  open,
  onSave,
  onDiscard,
  onClose,
  sessionStats,
  isLoading
}) => {
  const [sessionName, setSessionName] = useState(
    `Session ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
  );

  const handleSave = () => {
    if (sessionName.trim()) {
      onSave(sessionName.trim());
    }
  };

  const handleDiscard = () => {
    onDiscard();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && sessionName.trim()) {
      handleSave();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="save-session-dialog"
      disableEscapeKeyDown={isLoading}
    >
      <DialogTitle className="save-session-title">
        <span>💾 Save Session?</span>
        {!isLoading && (
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        )}
      </DialogTitle>

      <DialogContent className="save-session-content">
        {sessionStats && (
          <Box className="session-stats-summary">
            <Typography variant="body2" className="stats-label">
              Session Summary
            </Typography>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-value">{sessionStats.duration || '0:00'}</span>
                <span className="stat-label">Duration</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">{sessionStats.snapshots || 0}</span>
                <span className="stat-label">Data Points</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">{sessionStats.timeOnPointe || 0}s</span>
                <span className="stat-label">On Pointe</span>
              </div>
            </div>
          </Box>
        )}

        <Box className="session-name-input">
          <Typography variant="body2" className="input-label">
            Session Name
          </Typography>
          <TextField
            fullWidth
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter session name..."
            variant="outlined"
            autoFocus
            disabled={isLoading}
            className="name-input"
          />
        </Box>

        <Box className="action-buttons">
          <Button
            variant="outlined"
            color="error"
            onClick={handleDiscard}
            disabled={isLoading}
            className="discard-btn"
            startIcon={<Trash2 size={18} />}
          >
            Discard
          </Button>

          <Button
            variant="contained"
            onClick={handleSave}
            disabled={isLoading || !sessionName.trim()}
            className="save-btn"
            startIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : <Save size={18} />}
          >
            {isLoading ? 'Saving...' : 'Save Session'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SaveSessionModal;
